var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            direction: "rtl",
            size: "550px",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("goodsPage.package.Info")) + " "),
          ]),
          _vm.drawer
            ? _c(
                "el-form",
                {
                  ref: "form",
                  staticStyle: { padding: "16px" },
                  attrs: {
                    disabled: _vm.pageType == "view",
                    "label-position": "top",
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.Name"),
                                prop: "skuName",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t("goodsPage.package.Name"),
                                  clearable: "",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleQuery.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.form.skuName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "skuName", $$v)
                                  },
                                  expression: "form.skuName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.SKU"),
                                prop: "skuCode",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t("goodsPage.package.SKU"),
                                  clearable: "",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleQuery.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.form.skuCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "skuCode", $$v)
                                  },
                                  expression: "form.skuCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.Barcode"),
                                prop: "barCode",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t(
                                    "goodsPage.package.Barcode"
                                  ),
                                  clearable: "",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleQuery.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.form.barCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "barCode", $$v)
                                  },
                                  expression: "form.barCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.fee"),
                                prop: "activityPrice",
                              },
                            },
                            [
                              _c("BjInputMoney", {
                                attrs: {
                                  disabled: _vm.$store.getters.cusId,
                                  maxlength: 10,
                                  placeholder: _vm.$t("goodsPage.package.fee"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.activityPrice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "activityPrice", $$v)
                                  },
                                  expression: "form.activityPrice",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.$store.getters.cusId
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("goodsPage.package.Type"),
                                    prop: "packageType",
                                  },
                                },
                                [
                                  _c("BjSelectLov", {
                                    attrs: {
                                      disabled: _vm.pageType == "edit",
                                      placeholder: _vm.$t(
                                        "goodsPage.package.Type"
                                      ),
                                      "option-list": _vm.TypeOption,
                                    },
                                    model: {
                                      value: _vm.form.packageType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "packageType", $$v)
                                      },
                                      expression: "form.packageType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.$store.getters.cusId && _vm.form.packageType == "cus"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("billingPage.CustomerName"),
                                    prop: "cusId",
                                  },
                                },
                                [
                                  _c("BjSelectLov", {
                                    attrs: {
                                      disabled: _vm.pageType == "edit",
                                      "option-list": _vm.customerList,
                                      placeholder: _vm.$t(
                                        "billingPage.CustomerName"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.cusId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "cusId", $$v)
                                      },
                                      expression: "form.cusId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.$store.getters.cusId && _vm.form.packageType == "csg"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("goodsPage.package.Cost"),
                                    prop: "costPrice",
                                  },
                                },
                                [
                                  _c("BjInputMoney", {
                                    attrs: {
                                      maxlength: 10,
                                      placeholder: _vm.$t(
                                        "goodsPage.package.Cost"
                                      ),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.costPrice,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "costPrice", $$v)
                                      },
                                      expression: "form.costPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.$store.getters.cusId && _vm.form.packageType == "csg"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("goodsPage.package.Price"),
                                    prop: "salesPrice",
                                  },
                                },
                                [
                                  _c("BjInputMoney", {
                                    attrs: {
                                      maxlength: 10,
                                      placeholder: _vm.$t(
                                        "goodsPage.package.Price"
                                      ),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.salesPrice,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "salesPrice", $$v)
                                      },
                                      expression: "form.salesPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.Length"),
                                prop: "length",
                              },
                            },
                            [
                              _c("BjInputMoney", {
                                attrs: {
                                  maxlength: 10,
                                  placeholder: _vm.$t(
                                    "goodsPage.package.Length"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.length,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "length", $$v)
                                  },
                                  expression: "form.length",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.Width"),
                                prop: "width",
                              },
                            },
                            [
                              _c("BjInputMoney", {
                                attrs: {
                                  maxlength: 10,
                                  placeholder: _vm.$t(
                                    "goodsPage.package.Width"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.width,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "width", $$v)
                                  },
                                  expression: "form.width",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.Height"),
                                prop: "height",
                              },
                            },
                            [
                              _c("BjInputMoney", {
                                attrs: {
                                  maxlength: 10,
                                  placeholder: _vm.$t(
                                    "goodsPage.package.Height"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.height,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "height", $$v)
                                  },
                                  expression: "form.height",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("goodsPage.package.Weight"),
                                prop: "weight",
                              },
                            },
                            [
                              _c("BjInputMoney", {
                                attrs: {
                                  maxlength: 10,
                                  placeholder: _vm.$t(
                                    "goodsPage.package.Weight"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.weight,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "weight", $$v)
                                  },
                                  expression: "form.weight",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "foot" },
            [
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.pageType == "view", type: "primary" },
                  on: { click: _vm.onComfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }